import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "register-setting" }
const _hoisted_2 = { class: "register-setting__title register-setting-title" }
const _hoisted_3 = { class: "register-setting-title__label" }
const _hoisted_4 = { class: "register-setting__contains contains" }
const _hoisted_5 = {
  key: 0,
  class: "contains__first-register"
}
const _hoisted_6 = {
  key: 1,
  class: "contains__home-input"
}
const _hoisted_7 = {
  key: 2,
  class: "contains__upload-business"
}
const _hoisted_8 = {
  key: 3,
  class: "contains__upload-input"
}
const _hoisted_9 = {
  key: 4,
  class: "contains__linking-business"
}
const _hoisted_10 = {
  key: 5,
  class: "contains__linking-input"
}
const _hoisted_11 = {
  key: 6,
  class: "contains__finish-business"
}
const _hoisted_12 = {
  key: 7,
  class: "contains__finish-input"
}

import RegisterBusinessPageTab from '@/corePagesModule/components/RegisterBusinessPageTab.vue';
import { i18n } from '@/i18n';
import { useRegisterSettingStore } from './RegisterSettingStore';
import { storeToRefs } from 'pinia';
import FirstRegister from './components/FirstRegister.vue';
import HomeInput from './components/inputSetting/HomeInput.vue';
import UploadBusiness from './components/registerSetting/UploadBusiness.vue';
import UploadInput from './components/inputSetting/UploadInput.vue';
import LinkingBusiness from './components/registerSetting/LinkingBusiness.vue';
import FinishBusiness from './components/registerSetting/FinishBusiness.vue';
import { RegisterExcelBusinessInfoUseCase } from '../useCases/registerExcelBusinessInfoUseCase';
import { BusinessExcelInfosRepository } from '@/coreInfrastructureModule/Repositories/BusinessExcelInfosRepository';
import { UpsertBusinessesFromExcelUseCase } from '../useCases/UpsertBusinessesFromExcelUseCase';
import { UpsertBusinessesRepository } from '@/coreInfrastructureModule/Repositories/UpsertBusinessesRepository';
import { CreateCsvUseCase } from '@/exportFileUseCasesModule/createCsvUseCase';
import LinkingInput from './components/inputSetting/LinkingInput.vue';
import { PutExcelInputInfoAdapter } from '../adapters/PutExcelInputInfoAdapter';
import { InputExcelInfosRepository } from '@/coreInfrastructureModule/Repositories/InputExcelInfosRepository';
import { RegisterExcelInputInfoUseCase } from '../useCases/RegisterExcelInputInfoUseCase';
import FinishInput from './components/inputSetting/FinishInput.vue';
import { GetInputExcelInfoUseCase } from '../useCases/GetInputExcelInfoUseCase';
import { GetExcelInputInfoAdapter } from '../adapters/GetExcelInputInfoAdapter';
import { GetExcelBusinessInfoUseCase } from '../useCases/GetExcelBusinessInfoUseCase';
import { SettingRepository } from '@/coreInfrastructureModule/Repositories/SettingRepository';

export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterSettingPage',
  setup(__props) {

const t = i18n.t;

const store = useRegisterSettingStore(
  new GetInputExcelInfoUseCase(),
  new GetExcelInputInfoAdapter(),
  new GetExcelBusinessInfoUseCase(),
  new RegisterExcelBusinessInfoUseCase(),
  new BusinessExcelInfosRepository(),
  new UpsertBusinessesFromExcelUseCase(),
  new CreateCsvUseCase(),
  new RegisterExcelInputInfoUseCase(),
  new UpsertBusinessesRepository(),
  new InputExcelInfosRepository(),
  new PutExcelInputInfoAdapter(),
  new SettingRepository()
)();
const { state } = storeToRefs(store);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('登録/入力')), 1)
    ]),
    _createVNode(RegisterBusinessPageTab, { class: "register-setting__page-tab" }),
    _createElementVNode("div", _hoisted_4, [
      (_unref(state).mode === 'FirstRegister')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(FirstRegister, {
              onOnClickBack: () => {},
              onOnClickNext: _unref(store).onClickFirstPageNext,
              onOnClickDownloadTemplate: () => {},
              onOnClickRegisterSetting: () => {}
            }, null, 8, ["onOnClickNext"])
          ]))
        : _createCommentVNode("", true),
      (_unref(state).mode === 'HomeInput')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(HomeInput, { "register-setting-store": _unref(store) }, null, 8, ["register-setting-store"])
          ]))
        : _createCommentVNode("", true),
      (_unref(state).mode === 'UploadBusiness')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(UploadBusiness, {
              store: _unref(store),
              onOnClickBack: _unref(store).onClickUploadBusinessBack,
              onOnClickNext: _unref(store).onClickUploadBusinessNext
            }, null, 8, ["store", "onOnClickBack", "onOnClickNext"])
          ]))
        : _createCommentVNode("", true),
      (_unref(state).mode === 'UploadInput')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(UploadInput, {
              store: _unref(store),
              onOnClickBack: _unref(store).onClickUploadInputBack,
              onOnClickNext: _unref(store).onClickUploadInputNext
            }, null, 8, ["store", "onOnClickBack", "onOnClickNext"])
          ]))
        : _createCommentVNode("", true),
      (_unref(state).mode === 'LinkingBusiness')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(LinkingBusiness, {
              store: _unref(store),
              onOnClickBack: _unref(store).onClickLinkingBusinessBack,
              onOnClickNext: _unref(store).onClickLinkingBusinessNext,
              onOnClickUsePreviousValue: _unref(store).onClickLinkingBusinessUsePreviousValue
            }, null, 8, ["store", "onOnClickBack", "onOnClickNext", "onOnClickUsePreviousValue"])
          ]))
        : _createCommentVNode("", true),
      (_unref(state).mode === 'LinkingInput')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(LinkingInput, {
              store: _unref(store),
              onOnClickBack: _unref(store).onClickLinkingInputBack,
              onOnClickNext: _unref(store).onClickLinkingInputNext
            }, null, 8, ["store", "onOnClickBack", "onOnClickNext"])
          ]))
        : _createCommentVNode("", true),
      (_unref(state).mode === 'FinishBusiness')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(FinishBusiness, {
              store: _unref(store),
              onOnClickBack: _unref(store).onClickFinishBusinessBack
            }, null, 8, ["store", "onOnClickBack"])
          ]))
        : _createCommentVNode("", true),
      (_unref(state).mode === 'FinishInput')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(FinishInput, {
              store: _unref(store),
              onOnClickBack: _unref(store).onClickFinishInputBack
            }, null, 8, ["store", "onOnClickBack"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})